module.exports = __webpack_public_path__ + "img/menuboard_mc_cafe_large_alt.07860911.png";